import { v4 as uuidv4 } from 'uuid';

import { LabOrganization, RequisitionInput } from './API';

function buildRequisitionFromServiceRequestExternalIDs(
  labOrganization: LabOrganization,
  serviceRequestExternalIDs: string[],
): RequisitionInput;
function buildRequisitionFromServiceRequestExternalIDs(
  labOrganization: null | undefined,
  serviceRequestExternalIDs: null | undefined,
): null;
function buildRequisitionFromServiceRequestExternalIDs(
  labOrganization: LabOrganization | null | undefined,
  serviceRequestExternalIDs: string[] | null | undefined,
): RequisitionInput | null;
function buildRequisitionFromServiceRequestExternalIDs(
  labOrganization: LabOrganization | null | undefined,
  serviceRequestExternalIDs: string[] | null | undefined,
): RequisitionInput | null {
  if (serviceRequestExternalIDs == null || labOrganization == null) return null;

  const serviceRequests = serviceRequestExternalIDs.map((serviceRequestExternalID) => ({
    id: uuidv4(),
    externalID: serviceRequestExternalID,
  }));

  return {
    id: uuidv4(),
    labOrganization,
    serviceRequests,
  };
}

export default buildRequisitionFromServiceRequestExternalIDs;
